import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { getNestedProperty } from 'src/app/shared/utils/object-utils';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-ag-boolean-cell-renderer',
  templateUrl: './ag-boolean-cell-renderer.component.html',
  styleUrl: './ag-boolean-cell-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent],
})
export class AgBooleanCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  isActive: boolean;

  constructor() {}

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    this.setActive(params);
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.params = params;
    this.setActive(params);
    return true;
  }

  private setActive(params: any): void {
    // * a cellRendererSelector can hand us the flag directly; otherwise it is a
    // * path into the row params, configured on the colDef
    if (typeof params.isActive === 'boolean') {
      this.isActive = params.isActive;
      return;
    }

    const isActive = params.colDef?.cellRendererParams?.isActive;
    if (isActive) {
      this.isActive = !!getNestedProperty(params, isActive, false);
    } else {
      this.isActive = false;
    }
  }
}
